<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-3">
        <h5>チャットチーム一覧</h5>
      </div>
      <div class="col-5 text-right">
        <button id="createUserBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>      
        <button id="importBtn" type="button" class="btn-sm btn-outline-primary" v-on:click="importCsv">CSVをimportする</button>      
      </div>
    </div>
    <div class="row">
      <p></p>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="con-9" style="margin-left: 15px;">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="customSwitches" v-on:click="switchDeleted">
          <label class="custom-control-label" for="customSwitches">アプリから削除済みのチームを表示</label>
        </div>
      </div>
    </div>
    <div class="row">
      <p></p>
    </div>
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th scope="col" style="width:70px">#</th>
              <th scope="col">名称</th>
              <th scope="col" style="width:200px">更新日時</th>
              <th scope="col" style="width:150px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(room, index) in rooms" v-bind:key="room.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td>{{ room.roomName }}</td>
              <td>{{ room.lastModified }}</td>
              <td>
                <button type="button" class="btn-sm btn-light" v-on:click="modify(room.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-4">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms'],
  data: function(){
    return {
      rooms: [],
      message: '',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
      deleted: false
    }
  },
  computed: {
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    }
  },
  mounted() {
    if(this.$store.getters.hospital.id !== 0){
      this.search(true)
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
        }
      }
    )
  },
  methods: {
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/teams/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/teams/modify/'+id))
    },
    importCsv() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/teams/import'))
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          if(isInit){
            this.currentIndex = 0
          }
          var offset = this.currentIndex * this.limit
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var privilege = this.$store.getters.user.privilege
          var api = ""
          if(this.deleted){
            api = "/api/room/list/deleted/"
          } else {
            api = "/api/room/list/"
          }
          axios
            .post(api + offset, {
              type: 2, //team chat
              hospitalId: hospitalId,
              privilege: privilege
            },{
                headers: this.headers(accessToken)
            })
            .then(response => {
              this.rooms = response.data.data.rooms
              this.gridCount = this.rooms.length
            })
            .catch(err => {
              this.message = err.message
            })
        } else {
          this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
    switchDeleted(){
      /* トグルSWとbindしないでここでon/offしてるから想定外の何かでずれるのが心配
       * bindするとそっちの変更より先にswitchDeletedが動くから機能しない */
      this.deleted = !this.deleted

      this.currentIndex = 0
      this.search(false)
    }
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
#importBtn {
  margin-right: 10px;
}
.btn-sm{
  margin-left: 5px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>